/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { Link, useOutletContext } from 'react-router-dom';

import ExternalProviderContainer from '../../Auth/ExternalProvider/ExternalProviderContainer';
import { RETURN_URL_REGISTER } from '../../Auth/ExternalProvider/ReturnUrls';

import Layout from '../../Layout/Layout';
import SignUpForm from './SignUpForm';

import { useTranslator, useAppContext } from '@front-activerse/common-components';

import { currencySymbols } from '../../CheckoutMDS/const';

const SignUpContainer = ({
  register,
  redirectToPathAfterSuccess,
  action,
  loading,
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  loginButtonURL,
  productVariant,
}) => {
  const { trackFirebaseEvent } = useOutletContext();
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const {
    consts: { APP_BRAND },
  } = useAppContext();

  useEffect(() => {
    // action sripe means stripe register
    if (action === 'stripe') {
      trackFirebaseEvent('screen_view', {
        firebase_screen: 'stripe_signup',
      });
    }
  }, []);

  const { t } = useTranslator();

  let price = productVariant?.saleProduct?.price?.regular?.amount || null;
  let currency = productVariant?.saleProduct?.price?.regular?.currency || '';

  if (productVariant?.saleProduct?.price?.promo?.amount) {
    price = productVariant?.saleProduct?.price?.promo?.amount;
    currency = productVariant?.saleProduct?.price?.promo?.currency;
  }

  const renderPaymentMethods = () => {
    let appBrandWithApendix = '';
    if (APP_BRAND === 'dtba') {
      appBrandWithApendix = 'dl-space.fra1';
    } else if (APP_BRAND === 'hashimoto' || APP_BRAND === 'oxy') {
      appBrandWithApendix = `${APP_BRAND}.fra1`;
    } else {
      appBrandWithApendix = `${APP_BRAND}.sfo2`;
    }

    const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.userAgent);
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isMobileChrome = isChrome && /Mobile/.test(navigator.userAgent);
    const shouldShowApplePay = isMacLike && (isSafari || isMobileChrome);

    if (APP_BRAND === 'dtba') {
      return (
        <>
          <img
            className="me-m mb-m"
            src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/Stripe.svg`}
            alt="Stripe"
          />
          <img
            className="me-m mb-m"
            src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/CreditCards_Visa_MasterCard_Maestro.svg`}
            alt="Credit Cards"
          />
          {shouldShowApplePay && (
            <img
              className="me-m mb-m"
              src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/ApplePay.svg`}
              alt="Apple Pay"
            />
          )}
          <img
            className="me-m mb-m"
            src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/GooglePay.svg`}
            alt="Google Pay"
          />
          <img
            className="me-m mb-m"
            src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/Link.svg`}
            alt="Link"
          />
          <img
            className="me-m mb-m"
            src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/Klarna.svg`}
            alt="Klarna"
          />
        </>
      );
    }

    return (
      <>
        <img
          className="me-m mb-m"
          src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/Stripe.svg`}
          alt="Stripe"
        />
        <img
          className="me-m mb-m"
          src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/CreditCards_Visa_MasterCard_AmericanExpress.svg`}
          alt="American Express"
        />
        {shouldShowApplePay && (
          <img
            className="me-m mb-m"
            src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/ApplePay.svg`}
            alt="Apple Pay"
          />
        )}
        <img
          className="me-m mb-m"
          src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/GooglePay.svg`}
          alt="Google Pay"
        />
        <img
          className="me-m mb-m"
          src={`https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/web/cart/Link.svg`}
          alt="Link"
        />
      </>
    );
  };

  return (
    <Layout simpleLayout>
      <div className="page-template-auth full-height7">
        <Container className="py-xxl">
          <h1 className="text-center title-medium semi-bold mb-xl">{t('yourCart.title')}</h1>
          <Row>
            <Col xs={{ size: 12, order: 2 }} md={{ size: 6, order: 1 }}>
              <div className="page-container">
                <div className="auth-container">
                  <h1 className="text-center title-medium semi-bold mb-xl">{t('signUp.title')}</h1>
                  <ExternalProviderContainer
                    returnUrl={RETURN_URL_REGISTER}
                    action={action}
                    displayAppleButton={displayAppleButton}
                    displayFacebookButton={displayFacebookButton}
                    displayGoogleButton={displayGoogleButton}
                    isCheckboxChecked={isCheckboxChecked}
                  />
                  {(displayAppleButton || displayFacebookButton || displayGoogleButton) && (
                    <div className="line">
                      <span>{t('authorization.continueWithEmail.description')}</span>
                    </div>
                  )}
                  <SignUpForm
                    register={register}
                    loading={loading}
                    redirectToPathAfterSuccess={redirectToPathAfterSuccess}
                    action={action}
                    setIsCheckboxChecked={setIsCheckboxChecked}
                  />
                </div>
              </div>
              {loginButtonURL && (
                <p className="mt-xl text-center">
                  {t('authorization.alreadyHaveAnAccount')}{' '}
                  <Link to={loginButtonURL}>{t('authorization.logIn.button')}</Link>
                </p>
              )}
            </Col>
            <Col xs={{ size: 12, order: 1 }} md={{ size: 6, order: 2 }}>
              <div className="page-container">
                <div className="auth-container">
                  <h3 className="title-medium semi-bold mb-xl">
                    {t('paymentMethods.summary.title')}
                  </h3>
                  <div>
                    {productVariant ? (
                      <div className="d-flex justify-content-between">
                        <p className="mb-0 pe-4">{productVariant.saleProduct.name}</p>
                        <p className="mb-0 text-nowrap">
                          {price} {currencySymbols[currency]}
                        </p>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-between">
                        <p className="placeholder mb-0">Product name</p>
                        <p className="placeholder mb-0">Price</p>
                      </div>
                    )}

                    <hr />
                    <div className="d-flex justify-content-between">
                      <h3 className="title-medium semi-bold mb-0">
                        {t('paymentMethods.summary.total.title')}
                      </h3>
                      {productVariant ? (
                        <h3 className="title-medium semi-bold mb-0">
                          {price} {currencySymbols[currency]}
                        </h3>
                      ) : (
                        <h3 className="title-medium semi-bold placeholder mb-0">Price</h3>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-3 mb-xl">
                <p className="semi-bold mt-xl">{t('acceptedPaymentMethods.title')}</p>
                {renderPaymentMethods()}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

SignUpContainer.propTypes = {
  register: PropTypes.func.isRequired,
};

export default SignUpContainer;
